"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var EditableContext_1 = __importDefault(require("./EditableContext"));
var getInput = function (editable) {
    switch (editable.inputType) {
        case 'number':
            return react_1.default.createElement(antd_1.InputNumber, null);
        case 'text':
            return react_1.default.createElement(antd_1.Input, null);
        case 'boolean':
            return react_1.default.createElement(antd_1.Switch, null);
        case 'select':
            return (react_1.default.createElement(antd_1.Select, null, (editable.options || []).map(function (o) { return (react_1.default.createElement(antd_1.Select.Option, { key: "option-" + o.value, value: o.value }, o.text)); })));
        default:
            return react_1.default.createElement(antd_1.Input, null);
    }
};
var EditableCell = function (_a) {
    var dataIndex = _a.dataIndex, editable = _a.editable, record = _a.record, children = _a.children, editing = _a.editing, restProps = __rest(_a, ["dataIndex", "editable", "record", "children", "editing"]);
    var form = react_1.useContext(EditableContext_1.default);
    var renderCell = function (_a) {
        var getFieldDecorator = _a.getFieldDecorator;
        return editing ? (react_1.default.createElement(antd_1.Form.Item, { style: { margin: 0 } }, getFieldDecorator(dataIndex, {
            initialValue: record[dataIndex],
        })(getInput(editable)))) : (children);
    };
    return react_1.default.createElement("td", __assign({}, restProps), editable && form ? renderCell(form) : children);
};
exports.default = react_1.memo(EditableCell);
